import { render } from "./BookPage.vue?vue&type=template&id=ff1c237a&scoped=true"
import script from "./BookPage.vue?vue&type=script&lang=js"
export * from "./BookPage.vue?vue&type=script&lang=js"

import "./BookPage.vue?vue&type=style&index=0&id=ff1c237a&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1c237a"]])

export default __exports__